/**
 * 页面按钮权限控制
 * 页面按钮名称命名规则： 页面文件名称 + 按钮英文名称
 * 目前定义的名称如下：
 */

// 客户查询 = userGet, 创建用户 add, 导出 export, 编辑 edit, 删除 delete
// 客户创建 = userAdd, 创建用户 add, 批量删除 deletes

// 用户下单查询 = orderGet, 导出 export, 编辑 edit, 删除 delete, SMS批量推送 smsPush, 嗨回收批量推送 hhsPush, 源园再生推送 yyzsPush, 有闲有品推送 yxypPush
// 批量下单查询 = batchOrderGet, 预约 appoint, 派单 dispatch, 编辑 edit, 导出 export, 删除 delete, SMS批量推送 smsPush, 嗨回收批量推送 hhsPush, 源园再生推送 yyzsPush, 有闲有品推送 yxypPush

// 订单创建 = orderAdd, 创建订单 add, 批量删除 deletes
// 菜单管理 = menuManage, 新增 add, 编辑 edit, 删除 delete

// 组织管理 = orgManage, 创建组织 add,  编辑 edit,  删除 delete
// 角色权限管理 = roleAuth, 创建角色 add, 编辑 edit, 删除 delete
// 账号查询 = adminGet, 创建管理员 add,  编辑 edit, 删除 delete
// 师傅档案 = masterFile, 创建师傅 add,  批量创建师傅 adds, 编辑 edit, 禁用/启用 open/disabled, 删除 delete

// 区域展示价格管理 = areaManagement, 创建新区域 add, 批量删除 delete, 编辑 edit
// 实际价格回收管理 = actualPriceRecovery, 创建实际价格 add, 批量创建实际价格 adds

import Vue from 'vue'

/**
 * authList 后端有效数据示例
 * status: 0 // 0正常 1停用
 */
const authList = [
  // 客户查询
  {
    menuName: '创建用户111',
    menuType: 'F',
    perms: "userGet:add",
    status: 1
  },
  {
    menuName: '导出',
    menuType: 'F',
    perms: "userGet:export",
    status: 0
  },
  {
    menuName: 'edit',
    menuType: 'F',
    perms: "userGet:edit",
    status: 0
  },
  {
    menuName: '删除',
    menuType: 'F',
    perms: "userGet:delete",
    status: 0
  },
  // 客户创建
  {
    menuName: '创建用户',
    menuType: 'F',
    perms: "userGet:add",
    status: 0
  },
  {
    menuName: '删除',
    menuType: 'F',
    perms: "userGet:deletes",
    status: 0
  },
]

// 定义自定义指令
Vue.directive('btn-auth', {
  bind: function (el, binding, vnode) {
    const arg = binding.arg
    const currentBtnObj = authList.find((item) => item.perms === arg)
    console.log('===el', el)
    if (currentBtnObj.status == 0) {
      if (currentBtnObj.menuName) {
        el.textContent = currentBtnObj.menuName
      }
    } else {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})


// WEBPACK FOOTER //
// ./src/btnPermission.js